export enum ChannelName {
  SMS = 'SMS',
  EMAIL = 'EMAIL',
  PUSH_NOTIFICATIONS = 'PUSH_NOTIFICATIONS',
}
